module.exports = __webpack_public_path__ + "static/media/basement.96b2f89c.png";